<app-add-address *ngIf="(currentStepIndicatorIndex$ | async) === 1" [thirdpartyDocumentsAemContent]="thirdpartyDocumentsAemContent">
</app-add-address>
<app-select-accounts-funds *ngIf="(currentStepIndicatorIndex$ | async) === 2" [thirdpartyDocumentsAemContent]="thirdpartyDocumentsAemContent">
</app-select-accounts-funds>
<app-brokerage-type *ngIf="(currentStepIndicatorIndex$ | async) === 3" [thirdpartyDocumentsAemContent]="thirdpartyDocumentsAemContent">
</app-brokerage-type>
<app-review-and-submit *ngIf="(currentStepIndicatorIndex$ | async) === 4" [thirdpartyDocumentsAemContent]="thirdpartyDocumentsAemContent">
</app-review-and-submit>
<app-confirmation *ngIf="(currentStepIndicatorIndex$ | async) === 5" [thirdpartyDocumentsAemContent]="thirdpartyDocumentsAemContent">
</app-confirmation>
